import { apiClient } from '../../config/axios-client'
import type { ActivityAction } from '../../shared/enums/ActivityAction'
import type { GenerationStatus } from '../../shared/enums/GenerationStatus'
import type { Workspace, WorkspaceUpsert } from '../../shared/models/Workspace'

export const workspacesApi = {
  list: (skip: number, top: number, filter?: Record<string, unknown>) =>
    apiClient.get<Workspace[]>('workspaces', {
      params: { skip, top, ...filter },
    }),

  count: (filter?: Record<string, unknown>) =>
    apiClient.get<number>('workspaces/count', {
      params: { ...filter },
    }),

  detail: (id: string) => apiClient.get<Workspace>(`workspaces/${id}`),

  create: (data: WorkspaceUpsert) => apiClient.post<{ id: string }>('workspaces', data),

  update: (id: string, data: WorkspaceUpsert) =>
    apiClient.patch<Workspace>(`workspaces/${id}`, data),

  delete: (id: string) => apiClient.delete<unknown>(`workspaces/${id}`),

  // status: (workspaceId: string, action?: ActivityAction) =>
  //   apiClient.get<{ status: GenerationStatus }>(`workspaces/${workspaceId}/status`, {
  //     params: { action },
  //   }),
}
